import URLConfig from '@Config/urls/url.config';

export const BaseSettingsBankMenu = {
  name: 'Banque',
  level: 2,
  subMenu: [
    {
      name: 'Mise à jour',
      link: URLConfig.ADMIN.BASE_SETTINGS.BANK.UPDATE,
      level: 3,
    },
    {
      name: 'Systeme de paiement',
      link: URLConfig.ADMIN.BASE_SETTINGS.BANK.PAYMENT_SYSTEM,
      level: 3,
    },
    {
      name: 'Type de transactions',
      link: URLConfig.ADMIN.BASE_SETTINGS.BANK.TRANSACTION_TYPE,
      level: 3,
    },
    {
      name: 'Calendrier',
      link: URLConfig.ADMIN.BASE_SETTINGS.BANK.CALENDAR,
      level: 3,
    },
    {
      name: 'Dévise',
      link: URLConfig.ADMIN.BASE_SETTINGS.BANK.DEVISE.ROOT,
      level: 3,
    },
    {
      name: 'Commerçants',
      link: URLConfig.ADMIN.BASE_SETTINGS.BANK.MARCHANTS.ROOT,
      level: 3,
    },
    {
      name: 'Promotor',
      link: URLConfig.ADMIN.BASE_SETTINGS.BANK.PROMOTOR,
      level: 3,
    },
    {
      name: 'Commission Banque',
      link: URLConfig.ADMIN.BASE_SETTINGS.BANK.BANK_COMMISSION.ROOT,
      level: 3,
    },
    {
      name: 'Type Contrat',
      link: URLConfig.ADMIN.BASE_SETTINGS.BANK.CONTRAT_TYPE,
      level: 3,
    },
    {
      name: 'Niveau Solvabilité',
      link: URLConfig.ADMIN.BASE_SETTINGS.BANK.SOLVIBILITY_LEVEL,
      level: 3,
    },
    {
      name: 'Description des biens',
      link: URLConfig.ADMIN.BASE_SETTINGS.BANK.BIEN_DESC,
      level: 3,
    },
    {
      name: 'Type Income',
      link: URLConfig.ADMIN.BASE_SETTINGS.BANK.INCOME_TYPE,
      level: 3,
    },
    {
      name: 'Type Créancier',
      link: URLConfig.ADMIN.BASE_SETTINGS.BANK.CREANCIER_TYPE,
      level: 3,
    },
    {
      name: 'Type Assurance',
      link: URLConfig.ADMIN.BASE_SETTINGS.BANK.ASSURANCE_TYPE,
      level: 3,
    },
    {
      name: 'Paramètre Impression',
      link: URLConfig.ADMIN.BASE_SETTINGS.BANK.IMPRESSION_SETTINGS,
      level: 3,
    },
    {
      name: 'Paramètre Impression Champ',
      link: URLConfig.ADMIN.BASE_SETTINGS.BANK.IMPRESSION_SETTINGS_FIELDS,
      level: 3,
    },
    {
      name: 'Gestion des Riques',
      link: URLConfig.ADMIN.BASE_SETTINGS.BANK.RISK_MANAGEMENT.ROOT,
      level: 3,
    },
  ],
};
